import { useMutation } from 'react-query';

import * as RestApi from 'core/network/RestApi';
import { BulkRetargetingCampaign } from 'models/offsite/Campaign/BulkRetargetingCampaign';
import { generatePath } from 'react-router';
import { BulkRetargetingCampaignEndpoints } from '../constants';

export interface UpdateBulkRetargetingCampaignRequest {
  siteId: string;
  campaignId: string;
  campaign: Partial<BulkRetargetingCampaign>;
}

export const updateBulkRetargetingCampaign = (payload: UpdateBulkRetargetingCampaignRequest) => {
  return RestApi.put<BulkRetargetingCampaign, UpdateBulkRetargetingCampaignRequest['campaign']>(
    generatePath(BulkRetargetingCampaignEndpoints.PUT, payload),
    payload.campaign,
  );
};

export const useUpdateBulkRetargetingCampaignMutation = () => {
  return useMutation((payload: UpdateBulkRetargetingCampaignRequest) => updateBulkRetargetingCampaign(payload));
};
